import { Outlet, useLocation } from "react-router-dom";
import TopHeader from "@/components/TopHeader";
import BottomNav from "@/components/BottomNav";
import FrictionModal from "@/components/FrictionModal";
import { useState, useEffect } from "react";

const AppLayout = () => {
  const [frictionOpen, setFrictionOpen] = useState(false);
  const [frictionAction, setFrictionAction] = useState("join");
  const location = useLocation();

  useEffect(() => {
    const handler = (e) => {
      setFrictionAction(e.detail?.action || "join");
      setFrictionOpen(true);
    };
    window.addEventListener("grabb:friction", handler);
    return () => window.removeEventListener("grabb:friction", handler);
  }, []);

  const hideHeader = location.pathname.startsWith("/chats/") || location.pathname === "/create";

  return (
    <div className="min-h-screen bg-[#F8F9FA] pb-24" data-testid="app-shell">
      {!hideHeader && <TopHeader />}
      <main className="max-w-2xl mx-auto px-4 pb-8">
        <Outlet />
      </main>
      <BottomNav />
      <FrictionModal open={frictionOpen} onClose={() => setFrictionOpen(false)} action={frictionAction} />
    </div>
  );
};

export default AppLayout;
